var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class WeakIdCache {
  constructor() {
    __publicField(this, "cache", /* @__PURE__ */ new WeakMap());
    __publicField(this, "seed", 0);
    __publicField(this, "rootId", this.seedToId(this.seed++));
  }
  getId(key) {
    let existing = this.cache.get(key);
    if (existing === void 0) {
      this.cache.set(key, existing = this.seedToId(this.seed++));
    }
    return existing;
  }
  getOptionalKeyId(key) {
    if (key === void 0) {
      return this.rootId;
    }
    return this.getId(key);
  }
  seedToId(seed) {
    return seed.toFixed(0);
  }
}
export {
  WeakIdCache
};
//# sourceMappingURL=WeakIdCache.js.map
